import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { LampContainer } from "./lamp";
import { CarShowcase } from "./carShowcase";
import { ReactTyped } from "react-typed";

export function WelcomeHero() {
    const lampRef = useRef<HTMLDivElement>(null);
    const carRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (!lampRef.current || !carRef.current) return;

        // 1️⃣ Disable scrolling
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        // 2️⃣ Hide Car initially
        gsap.set(carRef.current, { opacity: 1 });

        // 3️⃣ Timeline for fade
        gsap.timeline({ delay: 6, onComplete: () => {
                // Re-enable scrolling after animation
                document.body.style.overflow = "auto";
            }})
            .to(lampRef.current, { opacity: 0, duration: 1, ease: "power1.out" } )


    }, []);

    return (
        <>
            <div ref={lampRef} className="absolute inset-0 flex items-center justify-center z-10">
                <LampContainer>
                    <p className="mt-8 bg-gradient-to-b from-[#a574bf] to-[#712177] py-4 bg-clip-text text-center text-4xl font-medium tracking-tight text-transparent md:text-7xl">



                        <ReactTyped strings={["Welcome to RGU Motorsports"]} typeSpeed={90}  />
                    </p>
                </LampContainer>
            </div>
            <div ref={carRef} className="absolute inset-0 flex items-center justify-center" id="car">
                <CarShowcase />
            </div>
        </>
    );
}
